import { setTrackView } from '@vfit/shared/data-access';
import { useTracking } from '@vfit/shared/data-access';
import { getUserInfo } from './clickToCallEnergy.utils';
import { useEffect } from 'react';
import { IClickToCallCallEnergy } from '@vfit/shared/components';

export const ClickToCallEnergyTagging = (props: IClickToCallCallEnergy) => {
  const { entryPoint, taggingOpts, pageProduct } = props || {};
  const { trackView, isReadyTrackView } = useTracking({
    event: ['starting_energy'],
    visitorTrackingOpts: getUserInfo(),
    disableInitialTrack: true,
  });
  setTrackView(trackView);

  useEffect(() => {
    trackView({
      desc: entryPoint,
      ...(taggingOpts && { ...taggingOpts }),
      ...(pageProduct && {
        ...pageProduct,
      }),
      versatile_prop: 'new ctc',
      page_type: 'ctc cmn',
      page_name_override: `Privati:CTC:CMN`,
      ignore_base_page_name: true,
      event_name: 'journey_start',
      event_category: 'journey',
      journey_type: 'journey',
      journey_name: 'CTC',
      product_target_segment: 'consumer',
      page_section: 'fixed offers',
      page_subsection: 'catalogo',
    });
  }, [isReadyTrackView]);

  return null;
};
